import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import faAngleRight from '@fortawesome/fontawesome-free-solid/faChevronRight';
import faAngleDown from '@fortawesome/fontawesome-free-solid/faChevronDown';
import styles from './ExpandableListItem.module.scss';
import { ListItem } from 'components';
import { classes } from 'common/util';

class ExpandableListItem extends React.Component {
  render() {
    const { className, children, opened, ...props } = this.props;

    return opened ? (
      <div className={classes(styles.expandable_list_item, className)}>
        <ListItem className={styles.category} {...props}>
          <FontAwesomeIcon className={styles.icon} fixedWidth icon={faAngleDown} />
        </ListItem>
        {children}
      </div>
    ) : (
      <ListItem className={classes(styles.category, className)} {...props}>
        <FontAwesomeIcon className={styles.icon} fixedWidth icon={faAngleRight} />
      </ListItem>
    );
  }
}

export default ExpandableListItem;

